/** Converts pixel value to rem value
 *  @param {number} pxValue - The value to convert to rem
 *  @return string - The rem string to set to the style attribute.
 * */
export function pxToRem(pxValue) {
  return `${pxValue / 16}rem`;
}
